import React from 'react';

export default function ChevronDownIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6">
      <path
        fillRule="evenodd"
        d="M11.8741 0.333496H10.6899C10.6093 0.333496 10.5335 0.362793 10.4862 0.41084L6.0003 4.9999L1.51444 0.41084C1.46707 0.362793 1.39128 0.333496 1.31075 0.333496H0.126518C0.0238846 0.333496 -0.0361164 0.420215 0.0238846 0.482324L5.59134 6.17881C5.79345 6.38506 6.20714 6.38506 6.40767 6.17881L11.9751 0.482324C12.0367 0.420215 11.9767 0.333496 11.8741 0.333496Z"
      />
    </svg>
  );
}
